import { ReactNode, useState } from 'react'
import RouteAccessDeniedModal from './RouteAccessDeniedModal'

export const RouteAccessDenied = ({
  customComponent,
}: {
  customComponent?: ReactNode
}) => {
  const [routeAccessDeniedModalOpen, setRouteAccessDeniedModalOpen] =
    useState(true)

  return customComponent ? (
    customComponent
  ) : (
    <RouteAccessDeniedModal
      open={routeAccessDeniedModalOpen}
      onClose={() => setRouteAccessDeniedModalOpen(false)}
    />
  )
}
